/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Classe7
 * @author    Matière Noire <contact@matierenoire.io>
 * @copyright 2018 Matière Noire
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://github.com/matiere-noire/classe7
 */

import ScrollMagic from 'scrollmagic'
import cssVars from 'css-vars-ponyfill'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import $ from 'jquery';
import 'slick-carousel'

if (typeof window.jQuery !== 'undefined' && typeof $.fn.slick === 'function' && typeof window.jQuery.fn.slick !== 'function') {
	window.jQuery.fn.slick = $.fn.slick;
}

gsap.registerPlugin(ScrollTrigger)

// Debuger scroll magic
//
// lancer la commande : yarn add scrollmagic-plugins --dev
//
// import { ScrollMagicPluginIndicator} from 'scrollmagic-plugins';
// ScrollMagicPluginIndicator(ScrollMagic);

/**
 * A ponyfill that provides client-side support for CSS custom properties (aka “CSS variables”) in legacy and modern browsers.
 * https://jhildenbiddle.github.io/css-vars-ponyfill/#/
 */
cssVars({})

/**
 * Sticky header
 */

// ScrollMagic controler

function isScrollMagicController(scrollController) {
	return scrollController
		&& typeof scrollController.addScene === 'function'
		&& typeof scrollController.removeScene === 'function'
}

function isScrollMagicScene(scrollScene) {
	return scrollScene
		&& typeof scrollScene.addTo === 'function'
		&& typeof scrollScene.destroy === 'function'
}

// TMAEX-4475 / Sentry 7790525080 : scène ou contrôleur invalide (homepage c-clean-services-3d.fr).
function addScrollMagicSceneToController(scrollScene, scrollController) {
	if (!isScrollMagicScene(scrollScene) || !isScrollMagicController(scrollController)) {
		return scrollScene
	}

	try {
		scrollScene.addTo(scrollController)
	} catch (error) {
		// Scène ou contrôleur déjà détruit / DOM détaché.
	}

	return scrollScene
}

function destroyScrollMagicScene(scrollScene) {
	if (!isScrollMagicScene(scrollScene)) {
		return
	}

	try {
		scrollScene.destroy(true)
	} catch (error) {
		// Scène déjà détruite ou contrôleur invalide.
	}
}

function canPinScrollMagicElement(element) {
	return element && element.isConnected && typeof element.offsetHeight === 'number'
}

function isValidScrollMagicDuration(duration) {
	return Number.isFinite(duration) && duration > 0
}

const controller = new ScrollMagic.Controller()

const initScrollMagic = () => {
    const stickyHeader = document.getElementById('sticky-header')
    const triggerHook = stickyHeader
        ? stickyHeader.offsetHeight / window.innerHeight
        : 0

    // Sous navigation
    const modules = document.querySelectorAll('.wp-block-classe7-modules-sticky')
    for (let module of modules) {
        const contentSibling = module.nextElementSibling
        if (!contentSibling) {
            continue
        }

        if (!canPinScrollMagicElement(module) || !canPinScrollMagicElement(contentSibling)) {
            continue
        }

        const moduleDuration = contentSibling.offsetHeight
        if (!isValidScrollMagicDuration(moduleDuration)) {
            continue
        }

        const moduleScene = new ScrollMagic.Scene({
            triggerElement: module,
            triggerHook,
            duration: moduleDuration
        })
            .setPin(module, {pushFollowers: false})

        addScrollMagicSceneToController(moduleScene, controller)
    }

    // Tour
    const tours = document.querySelectorAll('.wp-block-classe7-modules-container-style-2 .wp-block-classe7-modules.is-style-modules-2 .wp-block-group')
    for (let tour of tours) {

        const parent = tour.parentElement
        const contentSibling = parent?.nextElementSibling
        if (!contentSibling) {
            continue
        }

        //descriptionLow permet de faire en sorte que les élements de liens ne sortent plus du sticky (pour cause de trop petite description par rapport a une première desc plus longue)
        let descriptionLow = contentSibling.offsetHeight;
        const allTabsLink = tour.querySelectorAll('a')


        Array.prototype.slice.call(allTabsLink).forEach(function(accordion, index) {

            const href = accordion.getAttribute('href')
            if (!href || href.charAt(0) !== '#') {
                return
            }
            let descriptionId = href.substr(1)
            let description = document.getElementById(descriptionId);
            if (!description) {
                return
            }
            description.innerHTML="<div class='is-title-mobile'>"+accordion.innerHTML+"</div>" + description.innerHTML;

            if(description.hasAttribute("hidden")){
                description.removeAttribute("hidden");
                if(description.offsetHeight<descriptionLow){
                    descriptionLow = description.offsetHeight
                }
                if(window.innerWidth > 782){
                    description.setAttribute("hidden", "");
                }
            }

            window.addEventListener('resize', function() {
                if (window.innerWidth < 782) {
                    description.removeAttribute("hidden");
                }
                else {
                    description.setAttribute("hidden", "");
                }
                if(accordion==allTabsLink[0]){
                    accordion.click();
                }
            });
        });

        const tourHeader = tour.firstElementChild
        if (!canPinScrollMagicElement(tour) || !tourHeader) {
            continue
        }

        const tourDuration = descriptionLow - tourHeader.offsetHeight - 200 // 200 correspond au padding
        if (!isValidScrollMagicDuration(tourDuration)) {
            continue
        }

        const tourScene = new ScrollMagic.Scene({
            triggerElement: tour,
            triggerHook,
            duration: tourDuration
        })
            .setPin(tour, {pushFollowers: false})

        addScrollMagicSceneToController(tourScene, controller)
    }
}

window.onload = function() {
	const wpadminbar = document.getElementById('wpadminbar')
	const appSubheader = document.getElementById('app-subheader')

	const stickyHeader = document.getElementById('sticky-header')

	if (!stickyHeader) {
		initScrollMagic()
		return
	}

	// TMAEX-3644 : en dessous de 950px le header est en position sticky (CSS).
	// ScrollMagic le passait en position:fixed et l'ajout de visualViewport.offsetTop
	// au top le décalait vers le bas au scroll iOS.
	const mobileHeaderQuery = window.matchMedia('(max-width: 950px)')

	const computeStickyPosition = () => {
		let position = 0

		if (appSubheader && appSubheader.offsetParent !== null) {
			position += appSubheader.offsetHeight
		}

		if (wpadminbar) {
			position += wpadminbar.offsetHeight
		}

		return position
	}

	const opacityHeader = getComputedStyle(document.documentElement).getPropertyValue('--header-opacity')
	const needsMinOpacity = 0.5 > parseFloat(opacityHeader)

	const syncMobileHeaderVars = () => {
		const adminOffset = wpadminbar ? wpadminbar.offsetHeight : 0
		document.documentElement.style.setProperty('--admin-bar-offset', `${adminOffset}px`)
		document.documentElement.style.setProperty('--app-header-height', `${stickyHeader.offsetHeight}px`)
	}

	const syncMobileHeaderOpacity = () => {
		if (!needsMinOpacity || stickyHeader.classList.contains('open')) {
			return
		}

		stickyHeader.classList.toggle('min-opacity', window.scrollY >= computeStickyPosition())
	}

	let scene = null
	let position = computeStickyPosition()

	const clearPinStyles = () => {
		stickyHeader.style.position = ''
		stickyHeader.style.top = ''
		stickyHeader.style.left = ''
		stickyHeader.style.bottom = ''
		stickyHeader.style.right = ''
		stickyHeader.style.margin = ''
		stickyHeader.style.width = ''
	}

	const enableDesktopPin = () => {
		if (scene) {
			return
		}

		position = computeStickyPosition()
		stickyHeader.style.top = `${position}px`

		scene = new ScrollMagic.Scene({ offset: position }).setPin(stickyHeader)

		if (needsMinOpacity) {
			scene.setClassToggle(stickyHeader, 'min-opacity')
		}

		addScrollMagicSceneToController(scene, controller)
	}

	const disableDesktopPin = () => {
		if (scene) {
			destroyScrollMagicScene(scene)
			scene = null
		}

		clearPinStyles()
	}

	const applyHeaderMode = () => {
		if (mobileHeaderQuery.matches) {
			disableDesktopPin()
			syncMobileHeaderVars()
			syncMobileHeaderOpacity()
			return
		}

		enableDesktopPin()
	}

	applyHeaderMode()

	window.addEventListener('scroll', () => {
		if (mobileHeaderQuery.matches) {
			syncMobileHeaderOpacity()
		}
	}, { passive: true })

	// Resync desktop uniquement quand la hauteur du subheader ou de la
	// wpadminbar change. Pas de controller.update() sur le rubber-band
	// (cf. commit 8870266).
	let resyncTimer = null
	const resyncStickyHeader = () => {
		if (resyncTimer) {
			window.cancelAnimationFrame(resyncTimer)
		}
		resyncTimer = window.requestAnimationFrame(() => {
			if (mobileHeaderQuery.matches) {
				syncMobileHeaderVars()
				syncMobileHeaderOpacity()
				return
			}

			const newPosition = computeStickyPosition()
			if (newPosition !== position && scene) {
				position = newPosition
				stickyHeader.style.top = `${position}px`
				scene.offset(position)
				if (controller && typeof controller.update === 'function') {
					controller.update(true)
				}
			}
		})
	}

	window.addEventListener('orientationchange', resyncStickyHeader)
	if (window.visualViewport) {
		window.visualViewport.addEventListener('resize', resyncStickyHeader)
	}
	if (typeof mobileHeaderQuery.addEventListener === 'function') {
		mobileHeaderQuery.addEventListener('change', applyHeaderMode)
	}

	initScrollMagic()
}

/**
 * Scroll reveal
 */

const revealElements = document.querySelectorAll(
	'.is-style-circle-mask, ' +
    '.is-style-reveal-on-scroll, ' +
    'div[class^="wp-block-classe7-box"]:not([data-animation]) .wp-block-media-text__media, ' +
    '.wp-block-media-text__media:not([data-animation]), ' +
    '.classe7-icon-hover, ' +
    '.wp-block-embed, ' +
    '.wp-block-classe7-partenaires .wp-block-image, ' +
    '.wp-block-classe7-titre-chiffres-clefs .wp-block-column:not([data-animation]), ' +
    '.job-offers__service'
)
for (let i = 0; i < revealElements.length; i++) {
	const triggerElement = revealElements[i]
	// TMAEX-4475 : ignorer les nœuds détachés avant setClassToggle / addTo.
	if (!triggerElement || !triggerElement.isConnected) {
		continue
	}

	// create a scene for each element
	const revealScene = new ScrollMagic.Scene({
		triggerElement, // y value not modified, so we can use element as trigger as well
		offset: 50, // start a little later
		triggerHook: 0.8
	})
		.setClassToggle(triggerElement, 'visible') // add class toggle

	addScrollMagicSceneToController(revealScene, controller)
}

// TMAEX-4516 / Sentry 7796666049: guard invalid or empty data-animation (derelle.com actu.asp).
const parseAnimationData = (elem) => {
    const raw = elem?.dataset?.animation
    if (!raw || !String(raw).trim()) {
        return null
    }

    let animation
    try {
        animation = JSON.parse(raw)
    } catch (error) {
        if (!(error instanceof SyntaxError)) {
            throw error
        }
        // data-animation vide ou JSON tronqué (Sentry 7796666049).
        return null
    }

    if (!animation || typeof animation !== 'object') {
        return null
    }

    return animation
}

const animate = ( elem, scrollTrigger = true) => {
    const animation = parseAnimationData(elem)
    if (!animation) {
        return
    }

    let x = 0
    let y = 0
    let scale = 1
    if (animation.direction === 'up') {
        x = 0
        y = -120
    } else if (animation.direction === 'down') {
        x = 0
        y = 120
    } else if (animation.direction === 'left') {
        x = -120
        y = 0
    } else if (animation.direction === 'right') {
        x = 120
        y = 0
    } else if (animation.direction === 'fade') {
        x = 0
        y = 0
    } else if (animation.direction === 'zoom') {
        x = 0
        y = 0
        scale = 2
    }

    let toggleActions = 'play none none none';

    if (animation.repeat) {
        toggleActions = 'restart none none none';
    }

    let animParam = {
        x: x,
        y: y,
        scale: scale,
        opacity: 0,
        duration: animation.duration,
        delay: animation.delay,

    }


    if (scrollTrigger) {
        animParam.scrollTrigger = {
            trigger: elem,
            start: 'top 80%',
            toggleActions: toggleActions
        }
    }

    gsap.from(elem, animParam)
}
const animateElements = document.querySelectorAll(
    '[data-animation]'
)


for (let i = 0; i < animateElements.length; i++) {
    animate(animateElements[i])
}

/**
 * Open menu connexion (secondary)
 */
const secondaryNavToggleButton = document.getElementById('secondary-nav-toggle')

if (secondaryNavToggleButton) {
	const secondaryMenu = document.querySelector('.app-subheader .menu--secondary')

	secondaryNavToggleButton.addEventListener('click', () => {
		secondaryMenu?.classList.toggle('menu--secondary-open')
	})
}

/**
 * Open menu connexion (secondary)
 */
const secondaryNavToggleButtonResponsive = document.getElementById('secondary-nav-toggle-responsive')

if (secondaryNavToggleButtonResponsive) {
    const secondaryMenuResponsive = document.querySelector('.app-subheader-responsive .menu--secondary')

    secondaryNavToggleButtonResponsive.addEventListener('click', () => {
        secondaryMenuResponsive?.classList.toggle('menu--secondary-open')
    })
}

/**
 * Open menu
 */
const primaryNavToggleButton = document.getElementById('primary-nav-toggle')

if (primaryNavToggleButton) {
	const primaryMenu = document.querySelector('.app-header .menu--primary')
	const appSubheaderResponsive = document.getElementById('app-subheader-responsive')
	const appSubheader = document.getElementById('app-subheader')
	const stickyHeader = document.getElementById('sticky-header')

    const openMenu = () => {
		const isJacquelineMenu = stickyHeader?.classList.contains('menu-jacqueline-4')
			|| primaryMenu?.classList.contains('menu-jacqueline-4')

		if (primaryMenu) {
			primaryMenu.classList.toggle('open')
		} else if (isJacquelineMenu && stickyHeader) {
			stickyHeader.classList.toggle('open')
		}

		if (appSubheader) {
			appSubheader.classList.toggle('open')
		}
		if (appSubheaderResponsive) {
			appSubheaderResponsive.classList.toggle('open')
		}
		if (stickyHeader && !isJacquelineMenu && screen.width <= 950 ) {
			stickyHeader.classList.toggle('open')
		}

        // On ferme tous les sous menu ouvert
        if (primaryMenu) {
            const openSubMenu = primaryMenu.querySelectorAll('.mobile-sub-menu-open')
            openSubMenu.forEach(function(subMenu) {
                subMenu.classList.remove('mobile-sub-menu-open');
            })
        }
    }

	primaryNavToggleButton.addEventListener('click', openMenu)

    const primaryCloseNavButton = document.getElementById('primary-close-nav-toggle')

    if (primaryCloseNavButton) {
        primaryCloseNavButton.addEventListener('click', openMenu)
    }

    const backgroundNavToggleButton = document.getElementById('background-nav-toggle')

    if (backgroundNavToggleButton) {
        backgroundNavToggleButton.addEventListener('click', openMenu)
    }
}


const buttonLinks = document.querySelectorAll('.wp-block-button__link')

if (buttonLinks) {
    const primaryMenu = document.querySelector('.app-header')

    buttonLinks.forEach(function (buttonLink) {
        buttonLink.addEventListener('click', function(e) {
            const href = buttonLink.getAttribute('href')
            if (href && href.startsWith('#')) {
                document.location.href = href;
                window.scrollBy(0, -1 * primaryMenu.offsetHeight);

                e.preventDefault();
                return false;
            }
        })
    });
}

const menuItems = document.querySelectorAll('.app-header li.has-children')
Array.prototype.forEach.call(menuItems, function(el, i) {
	let timer

	el.addEventListener('mouseover', function(event) {
        Array.prototype.forEach.call(menuItems, function(el2, i) {
            el2.classList.remove('open')
        })
		el.classList.add('open')
		clearTimeout(timer)
	})
	el.addEventListener('mouseout', function(event) {
		timer = setTimeout(function(event) {
			el.classList.remove('open')
		}, 500)
	})

	el.querySelector('a.menu__link').addEventListener('click', function(event) {
		event.preventDefault()
		if (this.parentNode.classList.contains('has-children')) {
			this.parentNode.classList.add('mobile-sub-menu-open', 'open')
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'true')
		} else {
			this.parentNode.classList.remove('mobile-sub-menu-open', 'open')
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'false')
		}
	})
})

const primaryMenuButtonOpenSubMenu = document.querySelectorAll('.menu--primary .menu-item__open-sub-menu')

if (primaryMenuButtonOpenSubMenu) {
    primaryMenuButtonOpenSubMenu.forEach(function(button) {
        button.addEventListener('click', function(e) {
            const openSubMenu = button.closest('.mobile-sub-menu-open')
            openSubMenu?.classList.remove('mobile-sub-menu-open')
            e.preventDefault()
        })
    })
}

/**
 * Gestion du hover des actualité
 * @type {NodeListOf<Element>}
 */
const typePost = document.querySelectorAll('.entry--type-post')
if (typePost) {
	Array.prototype.forEach.call(typePost, function(el, i) {
		const link = el.querySelector('.entry__permalink')
		if (link){
			link.addEventListener('mouseenter', function() {
				el.classList.add('hover')
			})
			link.addEventListener('mouseleave', function() {
				el.classList.remove('hover')
			})
		}
	})
}
/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
;(function() {
	// Block accordéons — toggles only (aria-controls), not nested buttons in panel content (TMAEX-4471).
	const allButton = document.querySelectorAll(
		'.wp-block-classe7-accordion > button[aria-controls], .wp-block-classe7-accordion > div > button[aria-controls]'
	)

	const getModuleTabContainer = (link) => link?.parentElement?.parentElement

	const setModuleTabState = (link, className, add = true) => {
		const container = getModuleTabContainer(link)
		if (container) {
			container.classList[add ? 'add' : 'remove'](className)
		}
	}

	if (allButton) {
		const getAccordionContent = (accordionButton) => {
			const nextSibling = accordionButton.nextElementSibling
			if (nextSibling?.classList?.contains('classe7-accordion-content')) {
				return nextSibling
			}

			const controlsId = accordionButton.getAttribute('aria-controls')
			if (!controlsId) {
				return null
			}

			return document.getElementById(controlsId)
		}

		const closeAllAccordions = () => {
			Array.prototype.slice.call(allButton).forEach(function(accordion) {
				const accContent = getAccordionContent(accordion)
				if (accContent) {
					accContent.setAttribute('hidden', '')
				}
				accordion.setAttribute('aria-expanded', 'false')
			})
		}

		Array.prototype.slice.call(allButton).forEach(function(accordion) {
			accordion.addEventListener('click', function(event) {
				const isExpanded = 'true' === accordion.getAttribute('aria-expanded')
				const accContent = getAccordionContent(accordion)

				if (!isExpanded) {
					closeAllAccordions()
				}

				accordion.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')

				if (accContent) {
					if (isExpanded) {
						accContent.setAttribute('hidden', '')
					} else {
						accContent.removeAttribute('hidden')
					}
				}

				event.preventDefault()
			})
		})
	}

	// Modules, tabulation, tour
	const allModules = document.querySelectorAll('.wp-block-classe7-modules, .wp-block-classe7-modules-sticky, .wp-block-classe7-tabulations, .wp-block-classe7-tours')

    if (allModules) {

        // Pour chaque block on gére le clique sur le liens
        for (let module of allModules) {

            // On commence par cacher tout les contenus si nécéssaire
            const allTabLink = module.querySelectorAll('a[href^="#"]')
            const allTabContent = []

            const getTabContentFromLink = (tabLink) => {
                const href = tabLink.getAttribute('href')
                if (!href || '#' !== href.charAt(0)) {
                    return null
                }

                return document.getElementById(href.slice(1))
            }

            Array.prototype.forEach.call(allTabLink, tabLink => {
                const tabContent = getTabContentFromLink(tabLink)
                if (tabContent && !allTabContent.includes(tabContent)) {
                    allTabContent.push(tabContent)
                }
            })

            const validTabLinks = Array.prototype.filter.call(allTabLink, function(tabLink) {
                return Boolean(getTabContentFromLink(tabLink))
            })

            const closeAllTab = () => {
                allTabContent.forEach(function(moduleDescription) {
                    if (moduleDescription) {
                        moduleDescription.setAttribute('hidden', '')
                    }
                })
                validTabLinks.forEach(function(tabLink) {
                    if (!tabLink) {
                        return
                    }
                    tabLink.setAttribute('aria-expanded', 'false')
                    setModuleTabState(tabLink, 'current', false)
                })
            }

            const openAllTab = () => {
                Array.prototype.slice.call(allTabLink).forEach(function(tabLink) {
                    const description = getTabContentFromLink(tabLink)
                    if (!description) {
                        return
                    }
                    description.removeAttribute('hidden')
                    description.innerHTML="<div class='is-title-mobile'>"+tabLink.innerHTML+"</div>" + description.innerHTML;
                })
            }

            let initialiseScrollMagicTabScene = null
            const initialiseTab = () => {
                closeAllTab()
                const hash = window.location.hash

                let currentTab = allTabContent[0]
                let currentTabLink = validTabLinks[0]
                if (hash) {
                    const currentTabFromHash = allTabContent.find(function(tabContent) {
                        return `#${tabContent.getAttribute('id')}` === hash
                    })
                    if (currentTabFromHash) {
                        currentTab = currentTabFromHash
                    }

                    const currentTabLinkFromHash = Array.prototype.find.call(allTabLink, function(tabLink) {
                        return tabLink.getAttribute('href') === hash
                    })
                    if (currentTabLinkFromHash) {
                        currentTabLink = currentTabLinkFromHash
                    }
                }

                if (!currentTab) {
                    return
                }

                currentTab.removeAttribute('hidden')
                if (currentTabLink) {
                    currentTabLink.setAttribute('aria-expanded', 'true')
                    setModuleTabState(currentTabLink, 'current')
                }
            }

            if (module.classList.contains("wp-block-classe7-modules-sticky")) {

                if (0 < allTabContent.length && window.innerWidth >= 782) {
                    initialiseTab()
                } else if (0 < allTabContent.length) {
                    openAllTab()
                    module.style.display = 'none';
                }
            }
            else if (0 < allTabContent.length) {
                initialiseTab()
            }



            validTabLinks.forEach(function(accordion) {
                accordion.addEventListener('click', function(event) {
                    const accContent = getTabContentFromLink(accordion)

                    if (!accContent) {
                        return
                    }

                    closeAllTab()
                    accordion.setAttribute('aria-expanded', 'true')
                    setModuleTabState(accordion, 'current')
                    accContent.removeAttribute('hidden')

                    const animateElements = accContent.querySelectorAll('[data-animation]')
                    for (let i = 0; i < animateElements.length; i++) {
                        animate(animateElements[i], false)
                    }

                    const parrentGroup = module.closest('.wp-block-group')
                    const isTour = parrentGroup && parrentGroup.classList.contains('wp-block-classe7-modules-container-style-2');
                    const isTabulation = module.classList.contains('wp-block-classe7-tabulations');
                    const isSticky = module.classList.contains('wp-block-classe7-modules-sticky');

                    if ( isTour ) {
                        accContent.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
                    }
                    else if (isSticky) {
                        const stickyHeight = document.querySelector('.wp-block-classe7-modules-sticky').offsetHeight
                        const headerHeight = document.querySelector('#sticky-header').offsetHeight
                        const contentCoord = accContent.getBoundingClientRect().top

                        window.scrollTo({top: window.scrollY + contentCoord - stickyHeight - headerHeight, behavior: 'smooth'})
                    }
                    else if (!isTabulation) {
                        const linkCoord = accordion.getBoundingClientRect()
                        const contentCoord = accContent.getBoundingClientRect()

                        window.scrollTo({top:  window.scrollY - ( ( linkCoord.bottom + 124 )  - contentCoord.top  ), left: 0, behavior: 'smooth'})
                    }

                    event.preventDefault()
                })
                accordion.addEventListener('mouseenter', function() {
                    setModuleTabState(accordion, 'modules-hover')
                })
                accordion.addEventListener('mouseleave', function() {
                    setModuleTabState(accordion, 'modules-hover', false)
                })
            })
        }
    }

})()


// Block slider
function applyBlockCarouselAutoplay($carousel, slickInstance) {
	if (!$carousel || !$carousel.length) {
		return
	}

	const setAutoplay = (slick) => {
		if (!slick || typeof slick.slickSetOption !== 'function') {
			return
		}
		slick.slickSetOption('autoplaySpeed', 7000, true)
		slick.slickPlay()
	}

	if (slickInstance) {
		setAutoplay(slickInstance)
		return
	}

	if (!$carousel.hasClass('slick-initialized')) {
		return
	}

	const elSlick = $carousel.get(0)?.slick
	if (elSlick) {
		setAutoplay(elSlick)
		return
	}

	const $slickHost =
		typeof window.jQuery !== 'undefined'
			? window.jQuery($carousel[0])
			: $carousel
	const dataSlick = $slickHost.data('slick')
	if (
		!dataSlick ||
		typeof dataSlick.slickSetOption !== 'function'
	) {
		return
	}

	$slickHost
		.slick('slickSetOption', 'autoplaySpeed', 7000, true)
		.slick('slickPlay')
}

$(function() {
	const carousel$ =
		typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn?.slick === 'function'
			? window.jQuery
			: $

	if (typeof carousel$.fn.slick !== 'function') {
		return
	}

	const carouselSelector = '.wp-block-cb-carousel'
	const $carousels = carousel$(carouselSelector)

	if (0 === $carousels.length) {
		return
	}

	$carousels.filter('.slick-initialized').each(function() {
		applyBlockCarouselAutoplay(carousel$(this))
	})

	$carousels.on('init', function(event, slick) {
		applyBlockCarouselAutoplay(carousel$(this), slick)
	})
})

// Effet hover sur les box
const boxs = document.querySelectorAll('div[class^="wp-block-classe7-box"]')
if (boxs) {
	for (let box of boxs) {
		const boxLink = box.getElementsByTagName('a')
		if (boxLink.length > 0) {
			boxLink[0].addEventListener('mouseover', function (event){
				box.classList.add('box-hover')
			})
			boxLink[0].addEventListener('mouseout', function (event){
				box.classList.remove('box-hover')
			})
		}
	}
}

// Calcul hauteur quand il n'y a pas de bannière
document.addEventListener('DOMContentLoaded', () => {
	const blogHeader = document.getElementsByClassName('blog-header')[0];
	const bodyHasClass = document.body.classList.contains(
		'is-style-banner-full'
	   );
	const wpadminbar = document.getElementById('wpadminbar')
	const appHeader = document.getElementsByClassName('app-header')[0];

	let heightBanner = 0;

	if (wpadminbar) {
		heightBanner += wpadminbar.offsetHeight;
	}

	if (appHeader) {
		heightBanner += appHeader.offsetHeight;
	}

	if (bodyHasClass && blogHeader != undefined) {
		blogHeader.style.height = "calc(100vh - " + heightBanner + "px)";
	}
})

function getParentColumnMorphingBlocs(block) {
    let parentColumns = block.parentElement;
    while (parentColumns) {
        if (parentColumns.classList.contains("wp-block-columns")) {
            return parentColumns;
        }
        parentColumns = parentColumns.parentElement;
    }
    return null;
}

const scheduleMorphingBlockWhenImageReady = (block, callback) => {
    const img = block.querySelector('img');
    if (img) {
        if (img.complete) {
            callback(block);
        } else {
            img.addEventListener('load', () => callback(block));
        }
    } else {
        callback(block);
    }
};

const frontHeightMorphingBlocks = () => {

    const morphingBloc = document.getElementsByClassName('wp-block-classe7-morphingbloc');

    const frontHeightMorphingBlock = (block) => {
        const parentColumns = getParentColumnMorphingBlocs(block);
        if (!parentColumns?.hasAttribute("data-front-height")) {
            return;
        }

        const content = block.querySelector('.classe7-morphingbloc__content');
        if (!content) {
            return;
        }

        const frontHeight = parentColumns.getAttribute("data-front-height") + 'px';
        content.style.height = frontHeight;
        block.style.height = frontHeight;
    }

    for (let item of morphingBloc) {
        scheduleMorphingBlockWhenImageReady(item, frontHeightMorphingBlock);
    }
}

// Morphing bloc
const initMorphingBlocks = () => {
	const morphingBloc = document.getElementsByClassName('wp-block-classe7-morphingbloc');
	let Hcontainer = 0;

	// Logic pour un block
	const initMorphingBlock = (block) => {
		const front = block.querySelector('.classe7-morphingbloc__front');
		const back = block.querySelector('.classe7-morphingbloc__back');
		const content = block.querySelector('.classe7-morphingbloc__content');

		if (!front || !back || !content) {
			return;
		}

		// On recupère la hauteur ouverte du bloc
		const openHeigth = block.offsetHeight;
		const contentStyles = window.getComputedStyle(content);
		const frontHeigth = front.offsetHeight
			+ (parseInt(contentStyles.paddingTop, 10) || 0) * 2
			+ (parseInt(contentStyles.borderWidth, 10) || 0) * 2;

        const parentColumns = getParentColumnMorphingBlocs(block);

        if (parentColumns) {
            const existingFrontHeight = parentColumns.hasAttribute("data-front-height")
                ? parseInt(parentColumns.getAttribute("data-front-height"), 10)
                : 0;

            if (!parentColumns.hasAttribute("data-front-height") || frontHeigth > existingFrontHeight) {
                parentColumns.setAttribute("data-front-height", frontHeigth);
            }
        }

		content.style.height = frontHeigth + 'px'
		block.style.height = frontHeigth + 'px'

		// On cache le contenu à caché
		block.classList.add('init');
		block.classList.add('close');

		const backHeigth = back.offsetHeight;

		block.addEventListener('mouseover', function (event) {
			block.classList.remove('close');
			front.style.bottom = backHeigth + 'px'
			content.style.height = openHeigth + 'px'
		})

		// On cache le bloc au mouseout
		block.addEventListener('mouseout', function (event) {
			block.classList.add('close');
			front.style.bottom = 0
            if (parentColumns && parentColumns.hasAttribute("data-front-height")) {
                content.style.height = parentColumns.getAttribute("data-front-height") + 'px';
            }
            else{
                content.style.height = frontHeigth + 'px';
            }
		})
	}

	for (let item of morphingBloc) {
		scheduleMorphingBlockWhenImageReady(item, initMorphingBlock);
	}

    return new Promise((resolve,reject)=>{
            resolve();
    });
};


initMorphingBlocks();
setTimeout(function() {
    frontHeightMorphingBlocks()
}, 500);



document.addEventListener("DOMContentLoaded", function () {
    const modal = document.querySelector(".eb-modal-player");
    const stickyElement = document.querySelector(".wp-block-classe7-modules-sticky");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (stickyElement != null) {
                if (entry.isIntersecting) {
                    stickyElement.style.zIndex = "1"; // Quand le modal est visible
                } else {
                    stickyElement.style.zIndex = "99"; // Remet la valeur par défaut
                }
            }
        });
    }, { threshold: 0.1 });

    if (modal) {
        observer.observe(modal);
    }
});

